<template>
  <div style="background: #f7f7f7; width: min-content; min-width: 100%;">
    <table :class="classes">
      <thead>
      <slot></slot>
      </thead>
      <tbody>
      <tr v-if="!elementsPage.length" class="p-4 text-center">
        <td colspan="30">Список пуст...</td>
      </tr>
      <component
          v-for="(row, i) in elementsPage"
          :row="row"
          :key="i"
          :is="currentComponent"
          @row-click="onRowClick"
      />
      </tbody>
    </table>
  </div>
  <pagination-list v-model="page" :list="list" class="justify-end mr-4 mb-4"/>
</template>

<script>
// https://www.telerik.com/blogs/dynamic-components-vue-component
import TaskRow from '@/components/TaskRow'
import TaskRowArchive from '@/components/TaskRowArchive'
import DocsRow from '@/components/DocsRow'
import PaginationList from '@/components/PaginationList'

import { usePaginationStore } from '@/stores/pagination'
import { mapState } from 'pinia/dist/pinia'

export default {
  name: 'TableComponent',
  emits: ['row-click'],
  components: {
    PaginationList,
  },
  props: ['list', 'type', 'class'],
  data () {
    return {
      page: 1,
    }
  },
  computed: {
    ...mapState(usePaginationStore, ['paginationConfig']),
    elementsPage () {
      return this.list.filter((item, i) => {
        const max = this.page * this.paginationConfig.itemsPerPage,
            min = max - this.paginationConfig.itemsPerPage - 1

        return !(i <= min || i >= max)
      })
    },
    currentComponent () {
      if (this.type === 'tasks') {
        return TaskRow
      }
      else if (this.type === 'tasks-archive') {
        return TaskRowArchive
      }

      return DocsRow
    },
    classes () {
      let classes = ['table-inside']
      if (this.class) {
        classes.push(this.class)
      }
      return classes
    }
  },
  methods: {
    onRowClick(row) {
      this.$emit('row-click', row)
    }
  },
}
</script>
